import PageHead from "@/components/PageHead";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Printer, ArrowRight } from "lucide-react";
import { SPEAKER_NOTES } from "@/data/schools/speakerNotes";

const ORDER = [
  "/schools",
  "/schools/student",
  "/schools/parent",
  "/schools/counsellor",
  "/schools/studios",
  "/schools/portfolio",
  "/schools/reports",
];

export default function DemoScript() {
  const steps = ORDER.map((path) => ({ path, note: SPEAKER_NOTES[path] })).filter((s) => s.note);

  return (
    <>
      <PageHead
        title="Demo Script | WeKIT Education Intelligence"
        description="Presenter cheat sheet for the WeKIT Education Intelligence school walkthrough."
        path="/schools/script"
      />
      <div className="container max-w-3xl py-10 space-y-6">
        <header className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h1 className="text-3xl font-semibold tracking-tight">Demo script</h1>
            <p className="text-muted-foreground mt-1">
              Seven screens, about ten minutes. Read the headline, hit the bullets, use the transition.
            </p>
          </div>
          <div className="flex gap-2 print:hidden">
            <Button size="sm" variant="outline" onClick={() => window.print()}>
              <Printer className="w-3.5 h-3.5 mr-1" aria-hidden="true" /> Print
            </Button>
            <Button asChild size="sm">
              <Link to="/schools">
                Start the walk <ArrowRight className="w-3.5 h-3.5 ml-1" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </header>

        <ol className="space-y-4">
          {steps.map((s, i) => (
            <li key={s.path}>
              <Card>
                <CardContent className="p-6 space-y-3">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="w-7 h-7 rounded-full bg-primary/10 text-primary grid place-items-center text-sm font-semibold">
                      {i + 1}
                    </span>
                    <h2 className="text-lg font-semibold">{s.note!.headline}</h2>
                    {s.note!.timing && (
                      <span className="text-xs text-muted-foreground">{s.note!.timing}</span>
                    )}
                  </div>
                  <ul className="space-y-2 text-sm">
                    {s.note!.bullets.map((b) => (
                      <li key={b} className="flex gap-3">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2 shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                  {s.note!.transition && (
                    <p className="text-sm italic text-muted-foreground border-l-2 border-primary/40 pl-3">
                      “{s.note!.transition}”
                    </p>
                  )}
                  <Link
                    to={s.path}
                    className="inline-flex text-xs font-medium text-primary underline-offset-4 hover:underline print:hidden"
                  >
                    Open {s.path}
                  </Link>
                </CardContent>
              </Card>
            </li>
          ))}
        </ol>
      </div>
    </>
  );
}
